/**
 * Calculates the flat discount amount based on regular price, discount value, and discount type.
 */
export function getDiscountAmount(
  regularPrice: number,
  discount: number,
  discountType?: string | null
): number {
  if (discountType === "percentage") {
    return (regularPrice * (discount || 0)) / 100;
  }
  return discount || 0;
}

/**
 * Calculates the effective (discounted) price of a product or variation.
 */
export function getEffectivePrice(
  regularPrice: number,
  discount: number,
  discountType?: string | null
): number {
  const discountAmount = getDiscountAmount(regularPrice, discount, discountType);
  return Math.max(0, regularPrice - discountAmount);
}
